import { render, staticRenderFns } from "./assessment-mobile-placeholder.vue?vue&type=template&id=36bf153e&scoped=true&"
import script from "./assessment-mobile-placeholder.vue?vue&type=script&lang=ts&"
export * from "./assessment-mobile-placeholder.vue?vue&type=script&lang=ts&"
import style0 from "./assessment-mobile-placeholder.vue?vue&type=style&index=0&id=36bf153e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bf153e",
  null
  
)

export default component.exports